import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
const sliderBg = '/images/slider-bg.jpg';
const slider2 = '/images/slider2.jpg';
const slider3 = '/images/slider3.jpg';
const slider4 = '/images/slider4.jpg';
const slider5 = '/images/slider5.jpg';
const arrowDown = '/images/arrow-down.png';
const arrow2 = '/images/arrow2.jpg';
const arrow3 = '/images/arrow3.jpg';
const transportManagementSystem = '/images/transport_management_system.jpg';
const payroll = '/images/payroll.jpg';
const gpsTracker = '/images/gps_tracker.jpg';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeTab, setActiveTab] = useState('tms');

  const slides = [
    {
      image: sliderBg,
      title: 'GPS Tracking Anytime & Everywhere',
      description: 'Control your Fleet from any device',
      link: '/gps-tracking-software',
    },
    {
      image: slider4,
      title: 'Transport Management System',
      description: 'Solve complex transportation challenges across any mode.',
      link: '/transport-management-system',
    },
    {
      image: slider2,
      title: 'Payroll Management System',
      description: 'G Payroll is a payroll software designed with simplicity in mind.',
      link: '/payroll',
    },
    {
      image: slider3,
      title: 'Enterprise Resource Planning',
      description: 'Offering role-based access to critical applications, data, and analytical tools.',
      link: '/enterprise-resource-planning',
    },
    {
      image: slider5,
      title: 'GPS Tracking as Service',
      description: 'Control your Fleet from any device',
      link: '/gps-tracking-service',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Layout>
      <section className="slider">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="rslides" id="slider1">
            {slides.map((slide, index) => (
              <div
                key={index}
                style={{
                  display: index === currentSlide ? 'block' : 'none',
                  position: 'relative',
                  width: '100%',
                }}
              >
                <img src={slide.image} alt={`slide${index + 1}`} />
                <div className="caption">
                  <div className="caption-wrap">
                    <div className="caption-text">
                      <Link to={slide.link} title={slide.title}>
                        <h2 className="color1">
                          <span>{slide.title}</span>
                        </h2>
                        <p>
                          <span>{slide.description}</span>
                        </p>
                        <span role="button" className="btn btn-lg btn-primary">
                          Show More
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="clearfix"></div>
        <div className="scroll-down text-center slide-scroll">
          <a
            href="#our-products"
            title="Scroll Down"
            className="colorgrey"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('our-products');
            }}
          >
            Scroll Down<br />
            <img src={arrowDown} alt="arrow-down" />
          </a>
        </div>
      </section>

      <section className="our-products" id="our-products">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 text-center">
              <h2>
                <span className="heading-bg"></span>Our Products<span className="heading-bg"></span>
              </h2>
              <p className="colorWht">GreenOrange a one stop for all your Solutions</p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 text-center color1">
              <div id="tab-home">
                <ul className="nav nav-tabs" role="tablist">
                  <li role="presentation" className={activeTab === 'tms' ? 'active' : ''}>
                    <a
                      href="#tms"
                      aria-controls="tms"
                      role="tab"
                      title="Transport Management"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab('tms');
                      }}
                    >
                      transport management
                    </a>
                  </li>
                  <li role="presentation" className={activeTab === 'payroll' ? 'active' : ''}>
                    <a
                      href="#payroll"
                      aria-controls="payroll"
                      role="tab"
                      title="Payroll Management"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab('payroll');
                      }}
                    >
                      payroll management
                    </a>
                  </li>
                  <li role="presentation" className={activeTab === 'gps' ? 'active' : ''}>
                    <a
                      href="#gps"
                      aria-controls="gps"
                      role="tab"
                      title="GPS Tracking"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab('gps');
                      }}
                    >
                      GPS Tracking
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className={`tab-pane fade ${activeTab === 'tms' ? 'in active' : ''}`}
                    id="tms"
                  >
                    <div className="tab-pane-img pull-left">
                      <Link to="/transport-management-system" title="Transport Management System">
                        <img src={transportManagementSystem} alt="tms" />
                      </Link>
                    </div>
                    <div className="tab-pane-content pull-left">
                      <Link to="/transport-management-system" title="Transport Management">
                        <p>
                          Whether you operate your own private fleet or procure outside carrier
                          services, our Transportation Management software offers the scope of
                          solutions you need to run a comprehensive, integrated system-and achieve
                          better results than you ever thought possible. Fully cloud-enabled, the
                          solution set is available in multiple deployment options, including
                          multi-tenant, private hosted, on-premise or hybrid options.
                        </p>
                        <p className="text-center tab-home-btn">
                          <span role="button" className="btn btn-lg btn-default color1">
                            Show More
                          </span>
                        </p>
                      </Link>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className={`tab-pane fade ${activeTab === 'payroll' ? 'in active' : ''}`}
                    id="payroll"
                  >
                    <div className="tab-pane-img pull-left">
                      <Link to="/payroll" title="Payroll Management">
                        <img src={payroll} alt="payroll" />
                      </Link>
                    </div>
                    <div className="tab-pane-content pull-left">
                      <Link to="/payroll" title="payroll Management">
                        <p>
                          An integrated Payroll within your TMS Software will save you enourmous
                          number of hours required to generate payslips for your employees.
                        </p>
                        <p>
                          GPayroll helps you comply with legal and tax requirements and simplifies
                          the process of paying your employees. With GPayroll - you never need to
                          outsource your Payroll to a third party vendor.
                        </p>
                        <p>GPayroll supports both monthly salary and hourly wages structure.</p>
                        <p className="text-center tab-home-btn">
                          <span role="button" className="btn btn-lg btn-default color1">
                            Show More
                          </span>
                        </p>
                      </Link>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className={`tab-pane fade ${activeTab === 'gps' ? 'in active' : ''}`}
                    id="gps"
                  >
                    <div className="tab-pane-img pull-left">
                      <Link to="/gps-tracking-software" title="GPS Tracker">
                        <img src={gpsTracker} alt="gps_tracker" />
                      </Link>
                    </div>
                    <div className="tab-pane-content pull-left">
                      <Link to="/gps-tracking-software" title="GPS Tracking">
                        <p>
                          Not long ago it seemed that everything is already discovered in GSM
                          network, but HSCSD, GPRS, EDGE bearers created new possibilities for
                          remote control - M2M technology came up, which created new solutions.
                        </p>
                        <p>
                          M2M means machine-to-machine, man-to-machine and machine-to-mobile. M2M
                          extends understanding of communication, this is a way to communicate not
                          only for people, but for machines as well. In the mobile world M2M
                          together with communications and information technology help to
                          interconnect remote machines and objects, systems and people.
                        </p>
                        <p className="text-center tab-home-btn">
                          <span role="button" className="btn btn-lg btn-default color1">
                            Show More
                          </span>
                        </p>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="scroll-down text-center">
            <a
              href="#our-services"
              title="Scroll Down"
              className="colorgreen"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('our-services');
              }}
            >
              Scroll Down<br />
              <img src={arrow2} alt="arrow" />
            </a>
          </div>
        </div>
      </section>

      <section className="our-services" id="our-services">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 text-center color1">
              <h2 className="color1">
                <span className="heading-bg border1"></span>Our Services
                <span className="heading-bg border1"></span>
              </h2>
              <p className="our-serv-para">We offer a wide range of services to satisfy all our clients needs.</p>
            </div>
          </div>
          <div className="row text-center marTB40">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 padLR15">
              <article>
                <Link to="/applications" title="Applications">
                  <div className="services-icons">
                    <span>
                      <i className="fa fa-clipboard"></i>
                    </span>
                  </div>
                  <div className="clearfix"></div>
                  <h3>Applications</h3>
                  <p>
                    As organizations are evolving into Digital Businesses, their application estate is
                    set to take a giant leap. The 20th century was about building robust...
                  </p>
                </Link>
              </article>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 padLR15 padT30mob">
              <article>
                <Link to="/enterprise-resource-planning" title="ERP - Enterprise Resource Planning">
                  <div className="services-icons">
                    <span>
                      <i className="fa fa-cogs"></i>
                    </span>
                  </div>
                  <div className="clearfix"></div>
                  <h3>ERP</h3>
                  <p>
                    GreenOrange host the transportation management system (TMS), and integrates with
                    most legacy, Enterprise Resource Planning (ERP) applications...
                  </p>
                </Link>
              </article>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 padLR15 padT30mob">
              <article>
                <Link to="/consulting" title="Consulting">
                  <div className="services-icons">
                    <span>
                      <i className="fa fa-line-chart"></i>
                    </span>
                  </div>
                  <h3>Consulting</h3>
                  <p>
                    Operating environment for global organizations is increasingly getting complex.
                    While IT is no longer a support function in an organization...
                  </p>
                </Link>
              </article>
            </div>
          </div>
          <div className="row text-center padB30">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 padLR15">
              <article>
                <Link to="/mobility" title="Mobility">
                  <div className="services-icons">
                    <span>
                      <i className="fa fa-mobile"></i> <i className="fa fa-tablet"></i>
                    </span>
                  </div>
                  <h3>Mobility</h3>
                  <p>
                    Collaboration, connectivity and communication are the need of the hour for
                    organizations. It is a constant endeavor to improve...
                  </p>
                </Link>
              </article>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 padLR15 padT30mob">
              <article>
                <Link to="/business-process" title="Business Process">
                  <div className="services-icons">
                    <span>
                      <i className="fa fa-bar-chart"></i>
                    </span>
                  </div>
                  <h3>Business Process</h3>
                  <p>
                    Today, the world markets have matured to be highly industry, process and segment
                    specific, and there has been a major shift from the initial days of...
                  </p>
                </Link>
              </article>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 padLR15 padT30mob">
              <article>
                <Link to="/gps-tracking-service" title="GPS Tracking">
                  <div className="services-icons">
                    <span>
                      <i className="fa fa-map-signs"></i>
                    </span>
                  </div>
                  <h3>GPS Tracking</h3>
                  <p>
                    Not long ago it seemed that everything is already discovered in GSM network,
                    but HSCSD, GPRS, EDGE bearers created new possibilities for remote...
                  </p>
                </Link>
              </article>
            </div>
          </div>
          <div className="scroll-down text-center">
            <a
              href="#footer"
              title="Scroll Down"
              className="colorgrey"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('footer');
              }}
            >
              Scroll Down<br />
              <img src={arrow3} alt="arrow" />
            </a>
          </div>
        </div>
      </section>

      <section className="social-demo-phone">
        <div className="demo-top-bg"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 social-icons">
              <a href="https://www.linkedin.com/company/9228797" target="_blank" rel="noopener noreferrer">
                <i className="fa fa-linkedin"></i>
              </a>
              <a href="http://facebook.com/greenorangeit" target="_blank" rel="noopener noreferrer">
                <i className="fa fa-facebook"></i>
              </a>
              <a
                href="https://www.youtube.com/channel/UChNj0gs273A0o3xwY6KKkVA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-youtube"></i>
              </a>
              <a href="https://twitter.com/tweeGorange" target="_blank" rel="noopener noreferrer">
                <i className="fa fa-twitter"></i>
              </a>
              <a
                href="https://plus.google.com/106640608851875488305"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-google-plus"></i>
              </a>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 rqst-social-mob">
              <p className="text-center">
                <Link to="/contact" title="Request a Demo" className="btn btn-lg btn-default color3">
                  Request a Demo
                </Link>
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right colorWht">
              <div className="phone-no-btm">
                <i className="fa fa-phone"></i> +91 422 297 4960
                <p className="colorWht">Ask Question or Request a Demo</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Home;

